module.exports = __webpack_public_path__ + "img/left-blue.ce4692e.png";